module.exports = __webpack_public_path__ + "img/rocket-small.3da974d6.svg";